module.exports = __webpack_public_path__ + "static-portal/img/023.a182e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/023.jpg
// module id = EfCJ
// module chunks = 4